module.exports = __webpack_public_path__ + "img/blackPeople.c0157a89.png";